import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=33add7ba&scoped=true&"
import script from "./Cost.vue?vue&type=script&lang=js&"
export * from "./Cost.vue?vue&type=script&lang=js&"
import style0 from "./Cost.vue?vue&type=style&index=0&id=33add7ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33add7ba",
  null
  
)

export default component.exports